import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "componentRef" }
const _hoisted_2 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("button", {
        type: "button",
        title: "Show more information",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"]))
      }, [
        _createVNode(_component_Icon, {
          type: "solid",
          name: "question-mark-circle",
          class: "w-4 h-4"
        })
      ])
    ]),
    _renderSlot(_ctx.$slots, "help", {
      help: _ctx.help,
      show: _ctx.show
    }, () => [
      _withDirectives(_createElementVNode("p", { class: "text-xs text-gray-600" }, _toDisplayString(_ctx.help), 513), [
        [_vShow, _ctx.show]
      ])
    ])
  ], 512))
}